export enum CardItemStatus {
    Active= 'Active',
    Completed = 'Completed'
}
